import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export function RateSnapshot({ data }) {
  if (!data || !Array.isArray(data.cards) || !data.cards.length) return null;
  return (
    <section className="border-b border-slate-200 bg-white" data-testid="rate-snapshot">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {data.cards.map((c, i) => {
            const down = String(c.dir).toLowerCase() === "down";
            const Arrow = down ? ArrowDownRight : ArrowUpRight;
            return (
              <div
                key={i}
                data-testid={`rate-snapshot-card-${i}`}
                className="bg-white border border-slate-200 rounded-xl p-5 transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
              >
                <div className="font-num text-[11px] uppercase tracking-[0.15em] text-slate-400">{c.label}</div>
                <div className="text-sm text-slate-500 mt-0.5">{c.sub}</div>
                <div className="font-display text-3xl sm:text-4xl font-bold tracking-tighter text-slate-900 mt-3">
                  {c.value}
                </div>
                <div className={`flex items-center gap-1 font-num text-xs font-semibold mt-2 ${down ? "text-orange-600" : "text-emerald-600"}`}>
                  <Arrow className="w-3.5 h-3.5" /> {c.chg}
                </div>
              </div>
            );
          })}
        </div>
        {data.source && (
          <p className="font-num text-[10px] uppercase tracking-wider text-slate-400 mt-4">{data.source}</p>
        )}
      </div>
    </section>
  );
}
